import { ColDef, GridApi } from "ag-grid-community";
import _, { isEqual } from "lodash";
import LeadExportService from "../../../services/LeadExportService";



import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useCallback,  
  useMemo
} from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  setLeadCount,
  setLeadFilter,
  setLeadIds,
  updateSingleLead,
  userPreferences,
} from "../../../actions/actions";
import {
  assignLeadInList,
  copyLeadInList,
  deleteBulkLeads,
  filterLeads,
  getAllLeads,
  moveLeadInList,
  putUserPreferences,
} from "../../../services/leadService";
import DistributionChart from "../DistributionChart/DistributionChart";
import PopupComponent from "../../../components/PopupComponent";
import { areAllValuesUndefined } from "../../../utils/helpers";
import AgGrid, { IFetchRowsParams } from "../../common/grid/AgGrid";
import { CustomFieldsT } from "../customLeadForm";
import {
  assignedToRenderer,
  dateRenderer,
  labelRenderer,
  lastActivityRenderer,
  locationRenderer,
  nameRenderer,
  dateTimeRenderer,
  phoneRenderer,
  sourceRenderer,
  statusRenderer,
  saleValueRenderer, 
  campaignNameRenderer,
  formNameRenderer,
  phoneRendererTest, 
  createdByRenderer,
} from "./leads-renderers";
import { FilterParams, advanceFilterKeys } from "./leads.types";
import ContactLinksGenerator from "../../../utils/contactlinksgenerator";
import TaskDrawer from "../../common/TaskDrawer";
import CreateTaskForm from "../../../components/createTaskForm";
import CreateNoteForm from "../../../components/createNoteForm";
import { MdAddTask } from "react-icons/md";
import { MdOutlineNoteAdd } from "react-icons/md";
import BulkSelector from "../../../components/BulkSelector/bulkSelector";
import BulkLeadOptions from "../../../components/BulkLeadOptions/bulkLeadOptions";
import { useNavigate } from "react-router-dom";
import { setManuallyAutomate } from "../../../services/automationService";
import logger, { Logger } from '../../../utils/logger';
import SelectLeadStatus from "../../../components/status";
import SelectLeadLabel from "../../../components/label";
import { ChartLine } from "lucide-react";

import { updateLeadProducts } from "../../../services/leadService";
import MemoizedProductPickerPopup from "../../../components/ProductPickerPopup";
import BulkShareModal from "../../../components/BulkLeadOptions/BulkShareModal";
import { getAllContent } from "../../../services/contentService";
import { store } from "../../../store/store";
import { BaseColumnDefinition, ColumnRegistry, createCustomFieldColumnDef, getAllColumnDefs, getDefaultColumnOrder } from "../../../utils/columnRegistry";
import AssignLeadDrawer from "../../../components/AssignLeadDrawer";




export interface PreferenceI {
  status: Array<any>;
  labels: Array<any>;
  leadGridPreferences: {
    columnOrders: string[];
    columnWidths: { [colId: string]: number };
  };
  customForm: Array<CustomFieldsT>;
}

interface ProductWithQuantity {
  _id: string;
  name: string;
  price: number;
  quantity: number;
  // Add other fields as needed
}

export interface ILeadsGridProps {
  handleLeadClick: (rowData: any) => void;
  leadListData: Array<any>;
  setLeadListData: React.Dispatch<React.SetStateAction<any[]>>;
  onEditStatus: () => void;
  onEditLabel: (data?: any) => void; // Make data parameter optional with ?
  selectedItemCount: number;
  setSelectedItemCount: any;
  showBulk: boolean;
  onResetBulk: () => void;
  context?: any; 
  StoreData?: any; // Add access to StoreData
}

const LeadsGrid = forwardRef(
  (
    {
      handleLeadClick,
      leadListData,
      setLeadListData,
      onEditStatus,
      onEditLabel,
      selectedItemCount,
      setSelectedItemCount,
      showBulk,
      context,
      onResetBulk,
    }: ILeadsGridProps,
    ref
  ) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [resetGrid, setResetGrid] = useState<number>(0);
    const [openWithHeader, setOpenWithHeader] = useState<boolean>(false);
    // const [selectedItemCount, setSelectedItemCount] = useState<number>(0);

    const actionColumnClicked = useRef(''); // Store which column was clicked
    const [statusEditLead, setStatusEditLead] = useState<any>(null);
    const [selectedStatus, setSelectedStatus] = useState<string>("");
    const [showStatusPopup, setShowStatusPopup] = useState<boolean>(false);
    const [labelEditLead, setLabelEditLead] = useState<any>(null);
const [selectedLabel, setSelectedLabel] = useState<Array<string>>([]);
const [showLabelPopup, setShowLabelPopup] = useState<boolean>(false);

const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);


const [showAssignDrawer, setShowAssignDrawer] = useState(false);
const [selectedLeadsForAssign, setSelectedLeadsForAssign] = useState<string[]>([]);

const [showDistributionChart, setShowDistributionChart] = useState(false);
const [distributionField, setDistributionField] = useState('');

// Set default column definitions from the registry
const defaultColumnDefs: ColDef[] = getAllColumnDefs();

// Initialize state with default columns
const [columnDefs, setColumnDefs] = useState<ColDef[]>(defaultColumnDefs);

const [showBulkShareModal, setShowBulkShareModal] = useState<boolean>(false);
const [contentTemplates, setContentTemplates] = useState<any[]>([]);
const [selectedLeadsForShare, setSelectedLeadsForShare] = useState<any[]>([]);

const [productPickerOpen, setProductPickerOpen] = useState(false);
const [selectedLeadForProducts, setSelectedLeadForProducts] = useState<any>(null);
const [selectedProducts, setSelectedProducts] = useState<ProductWithQuantity[]>([]);

 
useEffect(() => {
  Logger.log('Grid Config:', {
    hasColumnDefs: !!columnDefs?.length,
    defaultColDef: defaultColumnDefs,
    rowSelection: gridApi.current?.getSelectedNodes()
  });
}, []);




    

    const { filterParam, leadCount } = useSelector(
      (state: any) => state.rootReducers.leads
    );
    const gridApi = useRef<GridApi | null>(null);
    const preferenceRef = useRef<PreferenceI | null>(null);
    const StoreData = useSelector((state: any) => {
      return state?.rootReducers;
    });

    const preferences: PreferenceI = useSelector(
      (state: { rootReducers: { user: { userPreferences: any } } }) =>
        state?.rootReducers?.user?.userPreferences
    );

// In LeadsGrid.tsx
const debouncedColumnMove = useRef(
  _.debounce((newColumnOrder: string[], preferences: PreferenceI) => {
    onColumnOrderChanged && 
      onColumnOrderChanged(newColumnOrder, preferences);
  }, 500)
).current;

    const debouncedColumnWidth = useRef(
      _.debounce((columnId, newWidth, preferences) => {
        onColumnWidthChanged &&
          onColumnWidthChanged(columnId, newWidth, preferences);
      }, 500)
    ).current;

    const handleExportLeads = async () => {
      try {
        const selectedIds = getSelectedLeadIds();
        await LeadExportService.exportBulkLeads(selectedIds);
      } catch (error) {
        console.error('Export failed:', error);
      }
    };

 
  const openDistributionChart = useCallback((field: string) => {
  logger.log('Opening distribution chart for field:', field);
  setDistributionField(field);
  setShowDistributionChart(true);
}, []);
    
    const closeDistributionChart = () => {
      setShowDistributionChart(false);
      setDistributionField('');
    };

   // Replace the handleStatusUpdate function with this improved version
const handleStatusUpdate = (updatedRows: any[]) => {
  Logger.log('Status update completed:', updatedRows);
  
  if (updatedRows && updatedRows.length > 0) {
    const updatedLead = updatedRows[0]; // Get the first updated lead
    
    // Log the updated lead for debugging
    Logger.log('Refreshing grid with updated lead:', {
      id: updatedLead._id,
      newStatus: updatedLead.status
    });
    
    if (gridApi.current) {
      // Method 1: Try to find and update the specific row
      const rowNode = gridApi.current.getRowNode(updatedLead._id);
      if (rowNode) {
        Logger.log('Found row node, updating directly');
        rowNode.setData(updatedLead);
        gridApi.current.refreshCells({ rowNodes: [rowNode], force: true });
      } else {
        // Method 2: If row node not found, do a more aggressive refresh
        Logger.log('Row node not found, doing full data refresh');
        
        // Get all current data
        const allData: any[] = [];
        gridApi.current?.forEachNode(node => {
          if (node.data) allData.push(node.data);
        });
        
        // Update the specific item in the data
        const index = allData.findIndex(item => item._id === updatedLead._id);
        if (index >= 0) {
          allData[index] = updatedLead;
          
          // Set the updated data back to the grid
          gridApi.current.setRowData(allData);
        } else {
          // Method 3: If all else fails, just do a full fetch
          Logger.log('Lead not found in current data, fetching all leads');
          fetchLeadsWrapper();
        }
      }
    }
  }
  
  // Reset state
  setShowStatusPopup(false);
  setStatusEditLead(null);
  setSelectedStatus("");
};
    
    // Add this to handle status popup closing
    const toggleStatusPopup = () => {
      setShowStatusPopup(false);
      setStatusEditLead(null);
      setSelectedStatus("");
    };
  

    const handleLabelUpdate = (updatedRows: any[]) => {
      Logger.log('Label update completed:', updatedRows);
      
      if (updatedRows && updatedRows.length > 0) {
        // Refresh the grid with updated data
        if (gridApi.current) {
          gridApi.current.refreshCells({ force: true });
        }
      }
      
      // Reset state
      setShowLabelPopup(false);
      setLabelEditLead(null);
      setSelectedLabel([]);
    };
    
    // Add this to handle label popup closing
    const toggleLabelPopup = () => {
      setShowLabelPopup(false);
      setLabelEditLead(null);
      setSelectedLabel([]);
    };

    // Inside the LeadsGrid component, add this function
const applyChartHeaders = useCallback((columns: ColDef[]) => {
  return columns.map(column => {
    // Cast to access the hasDistributionChart property
    const colDef = column as unknown as BaseColumnDefinition & ColDef;
    
    if (colDef.hasDistributionChart) {
      return {
        ...colDef,
        headerComponent: (params: any) => {
          return (
            <div className="flex items-center gap-2">
              <span>{colDef.headerName}</span>
              <ChartLine 
                className="cursor-pointer hover:text-blue-500"
                size={16}
                onClick={(e) => {
                  e.stopPropagation();
                  openDistributionChart(colDef.colId);
                }}
              />
            </div>
          );
        }
      };
    }
    
    return colDef;
  });
}, [openDistributionChart]);

    const fetchContentTemplates = async () => {
      try {
        Logger.log('Fetching content templates');
        // Use the existing getAllContent function with pagination
        const response = await getAllContent({
          page: 1,           // Starting page
          perPage: 500       // Number of items per page
        });
        
        if (response && response.status === 200) {
          setContentTemplates(response.data.data || []);
          Logger.log('Content templates fetched:', response.data.data?.length);
        }
      } catch (error) {
        console.error('Error fetching content templates:', error);
        toast.error('Failed to load content templates');
      }
    };
    
    // 4. Add function to handle bulk share action
    const handleBulkShare = async () => {
      Logger.log('Bulk share initiated');
      
      // Since we're in the grid component, we can access gridApi directly
      if (!gridApi || !gridApi.current) {
        toast.error('Unable to access lead grid');
        return;
      }
    
      // Get selected lead IDs directly
      const selectedNodes = gridApi.current.getSelectedNodes();
      if (!selectedNodes || selectedNodes.length === 0) {
        toast.error('Please select leads first');
        return;
      }
    
      // Fetch content templates if not already loaded
      if (contentTemplates.length === 0) {
        await fetchContentTemplates();
      }
    
      // Get lead data for the selected leads
      try {
        setIsLoading(true);
        
        // Extract the selected leads from the grid data
        const leadsData: any[] = [];
        
        selectedNodes.forEach((node: any) => {
          if (node.data) {
            leadsData.push({
              _id: node.data._id,
              name: node.data.name,
              phone: node.data.phone,
              email: node.data.email
            });
          }
        });
        
        setSelectedLeadsForShare(leadsData);
        setShowBulkShareModal(true);
      } catch (error) {
        console.error('Error preparing leads for bulk share:', error);
        toast.error('Failed to prepare leads for sharing');
      } finally {
        setIsLoading(false);
      }
    };

const sanitizeFilterParams = (params: FilterParams): FilterParams => {
  const sanitized = {...params};
  
  Object.keys(sanitized).forEach(key => {
      const value = sanitized[key];
      if (value === undefined || value === null || value === '') {
          delete sanitized[key];
      } else if (Array.isArray(value) && value.length === 0) {
          delete sanitized[key];
      } else if (typeof value === 'object' && !Array.isArray(value) && 
                 Object.keys(value).length === 0) {
          delete sanitized[key];
      }
  });

  return sanitized;
};

    
   



   // Update the getCustomColumnDef function in leads-grid.tsx

const getCustomColumnDef = (form: any, columnWidths: any) => {
  let cellRenderer;
  if (form.type === "location") {
    cellRenderer = locationRenderer;
  } else if (form.type === "date") {
    cellRenderer = dateRenderer;
  } else if (form.value === "saleValue") {
    cellRenderer = saleValueRenderer;
  } else if (form.value === "campaign_name") {
    cellRenderer = campaignNameRenderer;
  } else if (form.value === "formName") {
    cellRenderer = formNameRenderer;
  }
  
  // Determine the correct field path
  let field;
  if (["saleValue", "email"].includes(form.value)) {
    field = form.value;
  } else if (["campaign_name", "formName"].includes(form.value)) {
    field = `extraDetails.${form.value}`;
  } else {
    field = `extraDetails.${form.value}`;
  }
  
  return {
    headerName: form.label,
    sortable: false,
    width: columnWidths[form.value] || 150,
    field: field,
    colId: form.value,
    cellRenderer,
  };
};

   

const fetchLeadListOnScroll = (
  params: IFetchRowsParams,
  leadName?: string, // Keep parameter for now to avoid breaking change
  search?: string
) => {
  console.group('📜 Fetch on Scroll');
  
  // Get fresh state directly from Redux
  const currentState = store.getState().rootReducers;
  const currentReduxFilters = currentState.leads.filterParam;
  const currentLeadName = currentState.leadName.leadName;
  
  logger.log('FRESH Redux filters:', currentReduxFilters);
  logger.log('Current lead name from Redux:', currentLeadName);
  logger.log('Parameter leadName (will be ignored):', leadName);
  logger.log('StoreData.leadName:', StoreData?.leadName?.leadName?.id);
  
  // Use the fresh state
  let updatedFilterParams = {
    ...currentReduxFilters,
    sort: { orderBy: params.orderBy, isAscending: params.isAscending },
    paginationParams: { perPage: params.perPage, page: params.page },
  };
  
  logger.log('Final filter params (list ID from Redux):', updatedFilterParams);
  
  console.groupEnd();
  
  // IMPORTANT: No second parameter - use list ID from Redux state only
  return fetchLeads(updatedFilterParams);
};

    const handleRowClick = (params: any) => {
      // Detailed debugging log
      console.group('Row Click Debugging');
      Logger.log('Raw Params:', JSON.parse(JSON.stringify(params)));
      Logger.log('Params Type:', typeof params);
      Logger.log('Params Keys:', Object.keys(params));
      Logger.log('Data Property:', params.data);
      Logger.log('Is Data Undefined:', params.data === undefined);
      Logger.log('Stringified Data:', JSON.stringify(params.data));
      
      // Check our flag - if any protected column was clicked, skip processing
      logger.log('🔍 Action column flag:', actionColumnClicked.current);
      if (actionColumnClicked.current) {
        logger.log(`🛑 Skipping row click - ${actionColumnClicked.current} column was clicked`);
        actionColumnClicked.current = ''; // Reset for next time
        console.groupEnd();
        return;
      }
      
      console.groupEnd();
    
      // Extract data with your existing approach  
      const rowData = 
        params?.data || 
        params?.node?.data || 
        (typeof params === 'object' && !Array.isArray(params) ? params : null);
      
      // Comprehensive logging
      Logger.log('Extracted Row Data:', rowData);
      
      // Robust data extraction and validation
      if (!rowData) {
        Logger.warn('No valid row data could be extracted', {
          originalParams: params,
          extractionAttempts: [
            params?.data,
            params?.node?.data,
            typeof params === 'object' ? params : null
          ]
        });
        return;
      }
      
      // Ensure handleLeadClick is a function before calling
      if (typeof handleLeadClick !== 'function') {
        console.error('handleLeadClick is not a valid function');
        return;
      }
      
      try {
        handleLeadClick(rowData);
      } catch (error) {
        console.error('Error in handleLeadClick:', error);
      }
    };

    const comparePreferencesAreEqual = (newPref: any, oldPref: any) => {
      return isEqual(newPref, oldPref);
    };

    
    const onColumnOrderChanged = (
      orders: string[],
      preferences: PreferenceI
    ) => {
      const uniqueOrders = [...new Set(orders)];
      const leadGridPreferences = {
        ...preferences.leadGridPreferences,
        columnOrders: uniqueOrders,
      };
      if (
        !comparePreferencesAreEqual(
          leadGridPreferences,
          preferences.leadGridPreferences
        )
      ) {
        dispatch(
          userPreferences({
            ...preferences,
            leadGridPreferences,
          })
        );
        handleAddGridPreferences(leadGridPreferences);
      }
    };

    const onColumnWidthChanged = (
      colId: string,
      newWidth: number,
      preferences: PreferenceI
    ) => {
      const updatedColumnWidths = {
        ...(preferences.leadGridPreferences?.columnWidths || {}),
        [colId]: newWidth,
      };

      const leadGridPreferences = {
        ...preferences.leadGridPreferences,
        columnWidths: updatedColumnWidths,
      };

      if (
        !comparePreferencesAreEqual(
          leadGridPreferences,
          preferences.leadGridPreferences
        )
      ) {
        dispatch(
          userPreferences({
            ...preferences,
            leadGridPreferences,
          })
        );
        handleAddGridPreferences(leadGridPreferences);
      }
    };

    const handleAddGridPreferences = async (data: any) => {
      try {
        const response = await putUserPreferences({
          leadGridPreferences: data,
        });
        if (response && response.status) {
        }
      } catch (err: any) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Error while updating Source!");
        }
      }
    };

    const handleLabelClick = (data: any) => {
      if (!data || !data._id) {
        Logger.warn('No valid data for label click');
        return;
      }
      
      Logger.log('Label cell clicked with data:', data?._id);
      
      // Set the lead data for label update
      setLabelEditLead(data);
      setSelectedLabel(data?.label || []);
      
      // Trigger the onEditLabel callback
      onEditLabel(data);
    }

    const fetchLeadsWrapper = async () => {
      if (gridApi.current) {
        // Clear visible rows (doesn't purge cache)
        gridApi.current.setRowData([]);
        
        // Request refresh of infinite cache
        gridApi.current.refreshInfiniteCache();
        
        logger.log('Grid refreshed using setRowData + refreshInfiniteCache');
      }
    };

    
   

    
   // In LeadsGrid.tsx
// ENSURE fetchLeads in leads-grid.tsx is passing ALL parameters:
const fetchLeads = async (filterParam: FilterParams, leadName?: string) => {
  // Keep leadName parameter but don't use it
  console.group('🔄 Fetch Leads');
  
  logger.log('Incoming filter params:', filterParam);
  logger.log('leadName parameter (will be ignored):', leadName);
  
  try {
    setIsLoading(true);
    
    // Create the request object - DON'T override the list ID
    const requestParams = {
      ...filterParam, // Use filter params directly - list ID is already included
    };
    
    logger.log('Final API request (using list from Redux):', requestParams);
    
    const response = await filterLeads(requestParams);

    Logger.log('API Response:', {
      status: response?.status,
      totalRows: response?.data?.total,
      dataLength: response?.data?.data?.length,
      usedListId: requestParams.list // Log which list ID was actually used
    });

    if (response?.status === 200) {
      let responseData = response.data;
      dispatch(setLeadCount(responseData.total));
      return { 
        data: responseData.data, 
        totalRows: responseData.total 
      };
    }

  } catch (err) {
    console.error('❌ Fetch error:', err);
  } finally {
    setIsLoading(false);
    console.groupEnd();
  }
};
    

const getColunmmnDefs = () => {
  Logger.log('getColunmmnDefs returning:', 
    columnDefs.map(c => `${c.headerName} (${c.colId})`).join(', ')
  );
  return columnDefs;
};

  
const refreshCurrentPageInGridFn = (updatedRows: any[]) => {
  if (!gridApi.current) return;
  
  if (updatedRows && updatedRows.length > 0 && gridApi.current) {
    logger.log('Attempting direct node data update');
    
    // For each updated row
    updatedRows.forEach(updatedRow => {
      // Get all row nodes
      gridApi.current?.forEachNode(node => {
        // Check if this is the node we want to update
        if (node.data && node.data._id === updatedRow._id) {
          logger.log(`Updating node: ${updatedRow._id}`);
          
          // Create a merged version of the data
          const mergedData = {
            ...node.data,
            ...updatedRow
          };
          
          // Update the node data directly
          node.setData(mergedData);
        }
      });
    });
    
    // Force refresh of cells to make changes visible
    // This doesn't trigger data refetching, just visual refresh
    gridApi.current?.redrawRows();
    
    logger.log('✅ Direct node update and redraw complete');
  }
};
    
    const resetGridState = useCallback(() => {
      if (!gridApi.current) return;
      
      // Clear selection
      gridApi.current.deselectAll();
      
      // Reset data
      gridApi.current.setRowData([]);
      
      // Force refresh
      setResetGrid(prev => prev + 1);
    }, []);

// In leads-grid.tsx, complete onGridReady function
const onGridReady = (params: any) => {
  console.group('🎯 Grid Ready');
  Logger.log('Grid initialization:', {
    hasApi: !!params.api,
    rowCount: params.api?.getDisplayedRowCount(),
    currentFilter: filterParam
  });
  
  // Keep existing event listener for distribution chart
  params.api.addEventListener('openDistributionChart', (event: any) => {
    openDistributionChart(event.field);
  });
  
  gridApi.current = params.api;
  
  // Updated cell clicked handler with improved status and label handling
  params.api.addEventListener('cellClicked', (event: any) => {
    logger.log('📍 Cell clicked debug:', {
      colId: event.column.colId,
      data: event.data?._id
    });
    
    // Handle status cell click
    if (event.column.colId === 'status' && event.data) {
      actionColumnClicked.current = 'status';
      event.node.setSelected(false);
      
      // Set the lead data for status update
      setStatusEditLead(event.data);
      setSelectedStatus(event.data.status?.[0] || "");
      
      // Trigger the status popup
      setShowStatusPopup(true);
    }
    // Handle label cell click
    else if (event.column.colId === 'label' && event.data) {
      actionColumnClicked.current = 'label';
      event.node.setSelected(false);
      
      logger.log('📋 Label Cell Clicked - ID:', event.data._id, 'Full data:', event.data);
      
      // Set the lead data for label update
      setLabelEditLead(event.data);
      setSelectedLabel(event.data.label || []);
      
      // Trigger the onEditLabel callback with the FULL DATA
      // This ensures the ID is passed to the parent component
      if (typeof onEditLabel === 'function') {
        logger.log('📤 Sending lead data to parent with ID:', event.data._id);
        onEditLabel(event.data);
      }
    }
    // Handle sale value cell click
    else if (event.column.colId === 'saleValue' && event.data) {
      actionColumnClicked.current = 'saleValue';
      event.node.setSelected(false);
      
      // Open product picker for this lead
      if (gridContext.openProductPicker) {
        gridContext.openProductPicker(event.data);
      }
    }
    // Handle assignedTo cell click - NEW CODE
   else if (event.column.colId === 'assignedTo' && event.data) {
  actionColumnClicked.current = 'assignedTo';
  event.node.setSelected(false);
  
  // Call the handler from gridContext
  if (gridContext && typeof gridContext.onAssignedToClick === 'function') {
    logger.log('Opening assign drawer for:', event.data.name);
    gridContext.onAssignedToClick(event.data);
  } else {
    console.warn('Missing handler for assignedTo', {
      hasGridContext: !!gridContext,
      hasFunction: !!(gridContext && typeof gridContext.onAssignedToClick === 'function')
    });
  }
}
    // Handle other protected columns
    else if (['phone'].includes(event.column.colId)) {
      actionColumnClicked.current = event.column.colId;
      event.node.setSelected(false);
    }
  });
  
  console.groupEnd();
};

    // Fix the column mapping in the useEffect in leads-grid.tsx

    const handleProductsSelect = useCallback((products: ProductWithQuantity[]) => {
      if (!selectedLeadForProducts?._id) {
        console.error("No lead selected for product update");
        return;
      }
      
      logger.log("Products selected:", products.length);
      
      // Calculate total value
      const calculatedTotal = products.reduce(
        (sum, p) => sum + (p.price * p.quantity), 
        0
      );
      
      // Format products for API
      const productsForApi = products.map(p => ({
        id: p._id,
        quantity: p.quantity
      }));
      
      // Show loading toast
      const loadingToast = toast.loading("Updating lead...");
      
      // Call API to update products
      updateLeadProducts(
        selectedLeadForProducts._id,
        productsForApi,
        calculatedTotal
      )
        .then(response => {
          toast.dismiss(loadingToast);
          toast.success("Products updated successfully");
          
          logger.log("API response:", response?.data?.data);
          
          if (response?.data?.data) {
            const updatedLead = response.data.data;
            
            // Update the grid with the new data
            if (gridApi.current) {
              logger.log("Refreshing grid with updated lead");
              refreshCurrentPageInGridFn([updatedLead]);
            }
          }
        })
        .catch(error => {
          console.error("Product update error:", error);
          toast.dismiss(loadingToast);
          toast.error("Failed to update products");
        })
        .finally(() => {
          setProductPickerOpen(false);
          setSelectedLeadForProducts(null);
        });
    }, [selectedLeadForProducts, refreshCurrentPageInGridFn]);

    const gridContext = useMemo(() => ({
      openProductPicker: (leadData: any) => {
        logger.log("Opening product picker for:", leadData?.name);
        setSelectedLeadForProducts(leadData);
        
        // Initialize selected products from lead data
        if (leadData.products?.length > 0) {
          logger.log("Lead has existing products:", leadData.products.length);
          setSelectedProducts(leadData.products);
        } else {
          logger.log("No existing products for this lead");
          setSelectedProducts([]);
        }
        
        setProductPickerOpen(true);
      },
   onAssignedToClick: (leadData: any) => {
    logger.log("Opening assign drawer for lead:", leadData?.name);
    // Set the lead ID for assignment
    setSelectedLeadsForAssign([leadData._id]);
    // Open the assignment drawer
    setShowAssignDrawer(true);
  }
}), []);

    
    useEffect(() => {
  console.group('🔍 Column Processing Effect');
  logger.log('Effect triggered with dependencies:');
  logger.log('- preferences available:', !!preferences);
  logger.log('- onEditLabel available:', !!onEditLabel);
  
  if (!preferences) {
    logger.log('⚠️ No preferences available, skipping column processing');
    console.groupEnd();
    return;
  }
  
  logger.log('⏱️ Render timestamp:', new Date().toISOString());
  logger.log('👉 Processing columns at', performance.now().toFixed(2));
  
  preferenceRef.current = preferences;
  const userSelectedColumns = preferences.leadGridPreferences?.columnOrders || [];
  const columnWidths = preferences.leadGridPreferences?.columnWidths || {};

  logger.log('Column processing started:', {
    userSelectedCount: userSelectedColumns.length,
    userSelected: userSelectedColumns,
    widthsAvailable: Object.keys(columnWidths).length,
    hasStatusInPreferences: !!preferences.status,
    statusCount: preferences.status?.length || 0
  });
  
  // Define essential columns that should always be present
// ✅ ENHANCED - Handle missing essential columns gracefully:
logger.log('User selected columns:', userSelectedColumns);

let completeColumnList;

if (userSelectedColumns.length === 0) {
  // No preferences - use defaults
  completeColumnList = getDefaultColumnOrder();
  logger.log('No preferences - using defaults:', completeColumnList);
} else {
  // Check if essential columns are missing (backward compatibility)
  const essentialColumns = ['name', 'phone']; // Minimum required for functionality
  const missingEssentials = essentialColumns.filter(col => !userSelectedColumns.includes(col));
  
  if (missingEssentials.length > 0) {
    logger.log('Missing essential columns, adding them:', missingEssentials);
    completeColumnList = [
      ...missingEssentials,  // Add missing essentials at the start
      ...userSelectedColumns
    ];
  } else {
    // Use exactly what user selected (complete grid state)
    completeColumnList = userSelectedColumns;
  }
}

logger.log('Final column list (with essentials):', completeColumnList);
  
  logger.log('Complete column list (essential + user selected):', completeColumnList);
  
  // Process all columns to create column definitions
  let processingTime = performance.now();
  const processedColumns = completeColumnList
    .map(colId => {
      // Try to get from registry first
      if (ColumnRegistry[colId]) {
        const regCol = ColumnRegistry[colId];
        logger.log(`Processing column ${colId}:`, {
          headerName: regCol.headerName,
          renderer: regCol.cellRenderer?.name || 'undefined',
          value: regCol.field
        });
        
        // Create a copy of the column definition
        const columnDef = {
          headerName: regCol.headerName,
          field: regCol.field,
          colId: regCol.colId,
          width: columnWidths[colId] || regCol.width || 150,
          sortable: regCol.sortable !== undefined ? regCol.sortable : false,
          cellRenderer: regCol.cellRenderer,
          suppressNavigable: regCol.suppressNavigable,
          headerCheckboxSelection: colId === 'name',
          checkboxSelection: colId === 'name'
        };
        
        // For status and label columns, add the preferences to cellRendererParams
        if (colId === 'status') {
          logger.log(`Adding preferences to status column:`, {
            hasPreferences: !!preferences,
            statusCount: preferences.status?.length || 0
          });
          
          // Replace the cellRenderer with a wrapper function that includes preferences
          columnDef.cellRenderer = (params: any) => {
            return statusRenderer({ 
              ...params, 
              preferences, 
              onStatusClick: (data: any) => {
                setStatusEditLead(data);
                setSelectedStatus(data?.status?.[0] || "");
                setShowStatusPopup(true);
              }
            });
          };
        } 
        else if (colId === 'label') {
          logger.log(`Adding preferences to label column:`, {
            hasPreferences: !!preferences,
            labelsCount: preferences.labels?.length || 0
          });
          
          // Replace the cellRenderer with a wrapper function that includes preferences
          columnDef.cellRenderer = (params: any) => {
            return labelRenderer({ 
              ...params, 
              preferences,
              onLabelClick: (data: any) => {
                setLabelEditLead(data);
                setSelectedLabel(data?.label || []);
                onEditLabel(data);
              }
            });
          };
        }
        
        return columnDef;
      } 
      // Check if it's a custom field
      else if (preferences.customForm?.length) {
        const customField = preferences.customForm.find(f => f.value === colId);
        if (customField) {
          logger.log(`Processing custom field: ${colId} (${customField.label})`);
          return createCustomFieldColumnDef(customField, columnWidths);
        }
      }
      
      logger.log(`Column not found in registry or custom fields: ${colId}`);
      return null;
    })
    .filter(Boolean) as ColDef[];
  
  // Ensure we have at least name and phone if somehow everything is empty
  if (processedColumns.length === 0) {
    console.warn('No columns processed, falling back to defaults');
    const fallbackColumns = ['name', 'phone'].map(colId => {
      const col = ColumnRegistry[colId];
      return {
        ...col,
        width: columnWidths[colId] || col.width || 150,
        headerCheckboxSelection: colId === 'name',
        checkboxSelection: colId === 'name'
      };
    });
    processedColumns.push(...fallbackColumns);
  }
  
  // ADD CHART HEADERS TO COLUMNS
  processedColumns.forEach(col => {
    const regDef = ColumnRegistry[col.colId as string];
    if (regDef?.hasDistributionChart) {
      col.headerComponent = (params: any) => {
        return React.createElement(
          'div', 
          { className: 'flex items-center gap-2' },
          React.createElement('span', {}, col.headerName),
          React.createElement(ChartLine, {
            className: 'cursor-pointer hover:text-blue-500',
            size: 16,
            onClick: (e: any) => {
              e.stopPropagation();
              openDistributionChart(col.colId as string);
            }
          })
        );
      };
    }
  });
  
  logger.log(`Final column count: ${processedColumns.length}, Columns:`, 
    processedColumns.map(c => `${c.headerName} (${c.colId})`).join(', ')
  );
  
  // Add debug logging for status and label columns
  const statusColumn = processedColumns.find(c => c.colId === 'status');
  const labelColumn = processedColumns.find(c => c.colId === 'label');
  
  logger.log('Status column in final definitions:', {
    exists: !!statusColumn,
    hasCustomRenderer: typeof statusColumn?.cellRenderer === 'function'
  });
  
  logger.log('Label column in final definitions:', {
    exists: !!labelColumn,
    hasCustomRenderer: typeof labelColumn?.cellRenderer === 'function'
  });
  
  // Update the column definitions state
  logger.log('⏱️ Setting column definitions after', (performance.now() - processingTime).toFixed(2), 'ms');
  setColumnDefs(processedColumns);
  
  // Also update the grid directly if already initialized
  if (gridApi.current) {
    logger.log('Applying columns directly to grid API');
  
gridApi.current.setGridOption('columnDefs', processedColumns); // ✅ Modern API
  }
  
  logger.log('⏱️ Total column processing took', (performance.now() - processingTime).toFixed(2), 'ms');
  console.groupEnd();
}, [preferences, openDistributionChart]);

    // Expose fetchLeadListOnScroll function using useImperativeHandle
    useImperativeHandle(ref, () => ({
      fetchLeadsWrapper,
      refreshCurrentPageInGridFn,
      getColunmmnDefs,
      getSelectedLeadIds,
      handleSelection,
      handleUnSelect,
      resetGridState,
    }));

    const [action, setAction] = useState<string>("");
    const [leadId, setLeadId] = useState<string>("");

    // Function to select the next set of items
    const selectNextItems = (
      startIndex: number,
      total: number,
      allNodes: any[]
    ) => {
      const endIndex = Math.min(startIndex + total, allNodes.length);

      // Select the next rows
      for (let i = startIndex; i <= endIndex; i++) {
        allNodes[i]?.setSelected(true);
      }

      // Scroll to the last selected row
      if (endIndex > startIndex) {
        gridApi?.current?.ensureIndexVisible(endIndex - 1, "bottom");
      }

      return endIndex;
    };

    function isNearby(num1: number, num2: number, tolerance = 3) {
      return Math.abs(num1 - num2) <= tolerance;
    }

    const handleSelection = (total: number) => {
      if (!gridApi?.current) return;

      // const selectedNodes: any = gridApi.current.getSelectedNodes();

      let currentPageRows = gridApi.current.getRenderedNodes();

      let startIndex = 0;

      currentPageRows.forEach((node: any, i: number) => {
        if (node.selected) {
          startIndex = i;
        }
      });

      // Determine the starting index
      // const startIndex =
      //   selectedNodes.length > 0
      //     ? selectedNodes[selectedNodes.length - 1].rowIndex + 1
      //     : 0;

      startIndex = startIndex === -1 ? 0 : startIndex;

      let isAllSelected = gridApi.current
        .getRenderedNodes()
        .every((node: any) => node.selected);

      if (
        isAllSelected ||
        isNearby(startIndex, gridApi.current.getRenderedNodes()?.length)
      ) {
        gridApi.current.paginationGoToNextPage();

        // Retry selection after the next page loads
        setTimeout(() => {
          const newNodes: any = [];
          gridApi?.current
            ?.getRenderedNodes()
            .map((node) => newNodes.push(node));
          selectNextItems(0, total, newNodes); // Start from the beginning of the new page
        }, 500); // Adjust timeout based on page load time

        return;
      }

      // Get all rendered nodes
      const allNodes: any = [];
      gridApi.current.getRenderedNodes()?.map((node) => allNodes.push(node));

      // Select the next set of rows
      const endIndex = selectNextItems(startIndex, total, allNodes);

      // debugger;

      // If there are no more rows on the current page, navigate to the next page
      if (
        startIndex >= endIndex &&
        gridApi?.current?.paginationGoToNextPage
        //  ||
        // endIndex === gridApi.current.getRenderedNodes()?.length
      ) {
        gridApi.current.paginationGoToNextPage();

        // Retry selection after the next page loads
        setTimeout(() => {
          const newNodes: any = [];
          gridApi?.current
            ?.getRenderedNodes()
            .map((node) => newNodes.push(node));
          selectNextItems(0, total, newNodes); // Start from the beginning of the new page
        }, 500); // Adjust timeout based on page load time
      }
    };

    const handleUnSelect = () => {
      if (!gridApi?.current) return;

      gridApi?.current.forEachNode((node) => {
        node.setSelected(false);
      });

      gridApi?.current?.deselectAll();

      setSelectedItemCount(0);
      gridApi?.current?.paginationGoToPage(0);
      onResetBulk();
    };

    const onRowSelected = (event: any) => {
      if (event.node.selected) {
        setSelectedItemCount((prev: number) => prev + 1);
      } else {
        setSelectedItemCount((prev: number) => (prev === 0 ? 0 : prev - 1));
      }
    };

    const getSelectedLeadIds = () => {
      const selectedNodes: any = gridApi?.current?.getSelectedNodes();

      return selectedNodes?.map((e: any) => e.data._id);
    };

    const onDeleteLead = async () => {
      try {
        const leadIDs = getSelectedLeadIds();
        const response = await deleteBulkLeads({ leadIDs });
        reloadLeads();
      } catch (error) {}
    };

    const handleAssignLead = async (assignToUser: string) => {
      try {
        const leadIds = getSelectedLeadIds();
        const { data } = await assignLeadInList({ leadIds, assignToUser });

        toast.success(data?.message);
        reloadLeads();
      } catch (error) {
        Logger.log("err", error);
      }
    };

    const handleCopyLead = async (
      targetListId: string,
      activeLeadOption: string
    ) => {
      try {
        const data = {
          leadIDs: getSelectedLeadIds(),
          targetListId,
        };

        if (activeLeadOption == "copy") {
          const response = await copyLeadInList(data);
          toast.success(response?.data?.message);
        } else {
          const response = await moveLeadInList(data);
          toast.success(response?.data?.message);
        }

        reloadLeads();
      } catch (err) {}
    };
    const onRowClicked = (event: any) => {
      Logger.log('Click Event Details:', {
        hasNode: !!event.node,
        rowIndex: event.rowIndex,
        dataPresent: !!event.data,
        rowID: event.node?.id,
        currentPage: gridApi.current?.paginationGetCurrentPage()
      });
      
      if (onRowClicked && event.data) {
        onRowClicked(event.data);
      }
    };
    
    const handleSelectAutomate = async (automationId: string) => {
      try {
        const data = {
          leadIds: getSelectedLeadIds(),
          automationId,
        };

        const response = await setManuallyAutomate(data);
        toast.success(response?.data?.message);

        reloadLeads();
      } catch (err) {}
    };

    const reloadLeads = () => {
      gridApi.current?.refreshCells({ force: true });
      fetchLeadsWrapper();
    };

    const onCreateCampaign = () => {
      const leadIds = getSelectedLeadIds();
      dispatch(setLeadIds(leadIds));
      navigate("/createWhatsappBroadcast");
      reloadLeads();
    };

    return (
      <>
    
      {/* Bulk selector - appears when in bulk mode or items selected */}
{(showBulk || selectedItemCount > 0) && (
  <div style={{
    marginTop: 0,
    position: "relative",
    top: "10px",
    marginBottom: 20,
  }}>
    <BulkSelector
      selected={selectedItemCount}
      onSelect={handleSelection}
      onReset={handleUnSelect}
    />
  </div>
)}

{/* Bulk action options - now also appears when in bulk mode */}
{(showBulk || selectedItemCount > 0) && (
  <BulkLeadOptions
  onDeleteLead={onDeleteLead}
  handleAssignLead={handleAssignLead}
  handleCopyLead={handleCopyLead}
  onEditStatus={onEditStatus}
  onEditLabel={() => onEditLabel()} 
  onBulkTask={() => {
    setOpenWithHeader(true);
    setAction("addTask");
  }}
  onCreateCampaign={onCreateCampaign}
  handleSelectAutomate={handleSelectAutomate}
  onExportLeads={handleExportLeads}
  onBulkShare={handleBulkShare} // Add this prop
/>
)}
     
     {showBulkShareModal && (
      <BulkShareModal
        isOpen={showBulkShareModal}
        onClose={() => setShowBulkShareModal(false)}
        selectedLeads={selectedLeadsForShare}
        contentTemplates={contentTemplates}
      />
)}
        {/* Main grid container - scrollable */}
        <div style={{ 
      height: 'calc(100% - 48px)', // Account for pagination height
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        height: '100%',
        width: '100%',
        overflow: 'auto'
      }}>
<AgGrid
  columnDefs={columnDefs}
  fetchData={fetchLeadListOnScroll}
  onRowClick={handleRowClick}
  defaultData={leadListData}
  totalRows={leadCount}
  isLoading={isLoading}
  onColumnOrderChanged={(newColumnOrder) =>
    debouncedColumnMove(newColumnOrder, preferenceRef.current as PreferenceI)
  }
  onColumnWidthChanged={(columnId, newWidth) =>
    debouncedColumnWidth(columnId, newWidth, preferenceRef.current)
  }
  key={resetGrid}
  onGridReady={onGridReady}
  onRowSelected={onRowSelected}
  suppressPaginationPanel={true}
  pagination={true}
  paginationPageSize={50}
  context={gridContext}
  
/>
</div>
</div>
    
{showBulkShareModal && (
  <BulkShareModal
    isOpen={showBulkShareModal}
    onClose={() => setShowBulkShareModal(false)}
    selectedLeads={selectedLeadsForShare}
    contentTemplates={contentTemplates}
  />
)}
       
    
        {/* Task drawer */}
        <TaskDrawer
          openWithHeader={openWithHeader}
          setOpenWithHeader={setOpenWithHeader}
          onTaskDelete={() => {}}
          showDelete={false}
          drawerTitle={action === "addTask" ? "Add Task" : "Add Note"}
          size="xs"
        >
          {action === "addTask" && (
            <CreateTaskForm
              leadId={getSelectedLeadIds()}
              updateTaskValue={{}}
              action={action === "addTask" ? "add" : "Add Note"}
              status={""}
              drawerClose={() => {
                setOpenWithHeader(false);
                setAction("");
                handleUnSelect();
              }}
              fetchTaskStatusFollowUps={() => {}}
            />
          )}
    
          {action === "addNotes" && (
            <CreateNoteForm
              leadIds={[{ id: leadId }]}
              handleNotesSubmit={() => {
                setOpenWithHeader(false);
                setAction("");
              }}
            />
          )}
        </TaskDrawer>
        {statusEditLead && (
  <SelectLeadStatus
    showStatusPopup={showStatusPopup}
    toggleLeadStatus={toggleStatusPopup}
    onStatusChange={(e) => setSelectedStatus(e.target.value)}
    selectedStatus={selectedStatus}
    setShowStatusPopup={setShowStatusPopup}
    from="grid"
    id={statusEditLead._id}
    leadList={StoreData?.leadName?.leadName?.id || "0"}
    getLeads={() => {}}
    setOpenWithHeader={() => {}} 
    updateEditedRow={handleStatusUpdate}
  />
)}

{showDistributionChart && (
  <PopupComponent
    isOpen={showDistributionChart}
    onClose={closeDistributionChart}
    title="Distribution Analysis"
    size="lg"
  >
    <DistributionChart 
      field={distributionField}
      filterParams={{
        ...filterParam,
        // Add the list ID to match the grid's filter behavior
        ...(StoreData.leadName.leadName.id && StoreData.leadName.leadName.id !== "0" 
          ? { list: StoreData.leadName.leadName.id } 
          : {})
      }}
    />
  </PopupComponent>
)}

{labelEditLead && (
  <SelectLeadLabel
    showLabelPopup={showLabelPopup}
    toggleLeadLabel={toggleLabelPopup}
    onLabelChange={(e) => {
      if (!e?.target?.value) return;
      
      let newLabels = [...selectedLabel];
      const value = e.target.value;
      
      if (selectedLabel.includes(value)) {
        // Remove if already included
        newLabels = newLabels.filter(label => label !== value);
      } else {
        // Add if not included
        newLabels.push(value);
      }
      
      setSelectedLabel(newLabels);
    }}
    selectedLabel={selectedLabel}
    onLeadUpdate={(lead) => {}}
    setShowLabelPopup={setShowLabelPopup}
    from="grid"
    id={labelEditLead._id}
    leadList={StoreData?.leadName?.leadName?.id || "0"}
    getLeads={() => {}}
    setOpenWithHeader={() => {}} 
    LabelData={StoreData?.user?.userPreferences?.labels || []}
    updateEditedRow={handleLabelUpdate}
  />
)}
\{/* Add this at the end of your return statement in LeadsGrid */}

{productPickerOpen && selectedLeadForProducts && (
  <MemoizedProductPickerPopup
    key={`product-picker-${selectedLeadForProducts._id}`}
    isOpen={productPickerOpen}
    onClose={() => {
      logger.log("Closing product picker");
      setProductPickerOpen(false);
      setSelectedLeadForProducts(null);
    }}
    onProductsSelect={handleProductsSelect}
    initialSelectedProducts={selectedProducts}
    selectedProductIds={selectedProductIds} // Add this line
    excludeProductIds={[]}
    leadId={selectedLeadForProducts._id}
    leadName={selectedLeadForProducts.name}
    source="lead" 
  />
)}
{showAssignDrawer && (
  <AssignLeadDrawer
    isOpen={showAssignDrawer}
    onClose={() => setShowAssignDrawer(false)}
    leadIds={selectedLeadsForAssign}
    onAssignSuccess={(assignedToUserId, affectedLeadIds) => {
      // Update the leads in Redux store
      if (affectedLeadIds && affectedLeadIds.length > 0) {
        // Find each affected lead in the grid
        gridApi.current?.forEachNode(node => {
          if (node.data && affectedLeadIds.includes(node.data._id)) {
            // Create updated lead with new assignedTo value
            const updatedLead = {
              ...node.data,
              assignedTo: assignedToUserId
            };
            
            // Dispatch updateSingleLead action to update Redux
            dispatch(updateSingleLead(updatedLead));
            
            // Also update the grid data directly for immediate UI feedback
            node.setData(updatedLead);
          }
        });
      }
      
      // Close the drawer
      setShowAssignDrawer(false);
    }}
  />
)}

      </>
    );
  }
);

export default LeadsGrid;
